module.exports = __webpack_public_path__ + "img/WoSindDieZiegen.a4041837.svg";